<template>
  <div :class="cssMobileTheme" class="k-mobile-list text-weight-semi-bold">
    <Header :textColor="textColor">
      <div class="d-flex align-items-center text-size-18">
        <font-awesome-icon class="mr-1" :icon="['far', 'comment-dots']" />
        {{ headline }}
      </div>
    </Header>

    <div class="k-mobile-comments">
      <Comments
        :commentsList="pollComments"
        :canPostComment="canPostComment"
        :canSeeList="canSeeList"
        :disableAddCommentButton="allowComments"
        v-on:add="onAddComment"
        v-on:delete="onDeleteComment"
      ></Comments>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Comments from '@/components/Rendering/Comments.vue';
import Header from '@/components/Rendering/RenderMobileHeader.vue';
import { themeMixin } from '../mixins/ThemeMixins';
import { eventMixin } from '../mixins/EventMixins';
import { renderMixin } from '../mixins/RenderMixins';

export default {
  name: 'RendererMobileComments',
  props: {
    allowComments: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      curParticipant: 0,
    };
  },
  mixins: [themeMixin, eventMixin, renderMixin],
  components: {
    Comments,
    Header,
  },

  methods: {
    onAddComment(comment) {
      console.log('onAddComment:', comment);
      this.$store.dispatch('addComment', comment);
    },
    onDeleteComment(comment) {
      console.log('onDeleteComment:', comment);
      this.$store.dispatch('deleteComment', comment);
    },
  },

  computed: {
    ...mapActions(['addComment', 'deleteComment']),
    ...mapGetters(['pollComments', 'isOwner']),

    ...mapState({
      poll: (state) => state.poll.poll,
    }),

    headline() {
      if (this.isHiddenParticipantMode) {
        if (this.isOwner) {
          return this.$t('comments.headlineAdminHidden');
        }
        return this.$t('comments.headlineHidden').replace(
          '%s',
          this.poll.user.name
        );
      }
      return this.$t('comments.headline');
    },

    isMobileView() {
      return this.$store.state.mobileView;
    },

    participant() {
      return this.participants[this.curParticipant];
    },
    participantName() {
      return this.participants[this.curParticipant].name;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/colors.scss';

$bg-color: rgba(20, 20, 20, 0.7);
$bg-color: rgba(255, 255, 255, 0.3);

.dark-mode-bg-ff {
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
}

.dark-mode-bg {
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  color: white;
}

.light-mode-bg-ff {
  background-color: rgba(255, 255, 255, 0.7);
}

.light-mode-bg {
  background-color: $bg-color;
  backdrop-filter: blur(10px);
  color: #1d1d1d;
}

.content {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
}

.k-paging {
  display: flex;
}

.k-left-icon,
.k-right-icon {
  flex-basis: 70px;
  display: flex;
  color: $primary;
}

.k-left-icon {
  justify-content: flex-start;
  align-items: flex-start;
}

.k-right-icon {
  justify-content: flex-end;
  margin-left: auto;
}

.k-mobile-comments {
  padding-top: 10px;
}
</style>
